import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/projects/',
    name: 'projects',
    component: () => lazyLoadView(import('@pages/projects/show.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/project/:id/methodologists/',
    name: 'project.methodologists',
    component: () => lazyLoadView(import('@pages/methodologists/show.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/expert/',
    name: 'expert',
    component: () =>
      lazyLoadView(import('@pages/methodologists/my-projects.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          const currSession = store.getters['auth/currentSession']
          if (currSession && currSession.publicProject) {
            next(currSession.publicProject.indexPath)
          } else next()
        } else {
          // Continue to the login page
          next()
        }
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/project/:id/experts/',
    name: 'project.experts',
    component: () => lazyLoadView(import('@pages/experts/show.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/project/:id/:data/',
    name: 'project.data',
    component: () => lazyLoadView(import('@pages/project-data/show.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/variable/:project_id/:id/sceneries',
    name: 'variable.sceneries',
    component: () => lazyLoadView(import('@pages/project-data/sceneries.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/expert/projects/',
    name: 'expert.projects',
    component: () => lazyLoadView(import('@pages/experts/my-projects.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/expert/project/:project_id/detail',
    name: 'expert.project.detail',
    component: () => lazyLoadView(import('@pages/experts/project-detail.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession || {} }),
  },
  {
    path: '/expert/project/:project_id/:profile_id/rate/variables',
    name: 'expert.project.rate.variables',
    component: () =>
      lazyLoadView(import('@pages/experts/expert-variable-rate.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/expert/project/:project_id/:profile_id/choose/areas',
    name: 'expert.choose.areas',
    component: () => lazyLoadView(import('@pages/experts/choose-areas.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/expert/project/:project_id/:profile_id/rate/areas',
    name: 'expert.project.rate.areas',
    component: () =>
      lazyLoadView(import('@pages/experts/expert-area-rate.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/expert/project/:project_id/:profile_id/rate/sceneries',
    name: 'expert.project.rate.sceneries',
    component: () =>
      lazyLoadView(import('@pages/experts/expert-scene-rate.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/project/:project_id/expert/:profile_id/reports/change_factor',
    name: 'project.expert.report.change',
    component: () =>
      lazyLoadView(import('@pages/experts/reports/change-factor.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/project/:project_id/expert/:profile_id/reports/estrategic_vars',
    name: 'project.expert.report.estrategic_vars',
    component: () =>
      lazyLoadView(import('@pages/experts/reports/estrategic-vars.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/project/:project_id/reports/change_factor',
    name: 'project.expert.report.change_factor',
    component: () =>
      lazyLoadView(import('@pages/experts/reports/change-factor-gen.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/project/:project_id/reports/estrategic_vars',
    name: 'project.expert.report.strategic',
    component: () =>
      lazyLoadView(import('@pages/experts/reports/estrategic-vars-gen.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/report/project/matrix/:project_id/',
    name: 'report.project.matrix',
    component: () =>
      lazyLoadView(import('@pages/methodologists/reports/matrix.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/project/:project_id/expert/:profile_id/reports/sceneries',
    name: 'report.project.sceneries',
    component: () =>
      lazyLoadView(import('@pages/experts/reports/sceneries.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/project/:project_id/reports/sceneries-gen',
    name: 'report.project.sceneries.gen',
    component: () =>
      lazyLoadView(import('@pages/experts/reports/sceneries-gen.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/report/project/morph-analysis/:project_id/',
    name: 'report.project.morphanalysis',
    component: () =>
      lazyLoadView(import('@pages/experts/reports/morph-analysis.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/pronostics/',
    name: 'pronostics',
    component: () => lazyLoadView(import('@views/pronostics/index.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/pronostics/projects/',
    name: 'pronostics.projects',
    component: () => lazyLoadView(import('@pages/forecasters/my-projects.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentSession.user || {} }),
  },
  {
    path: '/pronostic/:id/questions/',
    name: 'pronostic.questions',
    component: () => lazyLoadView(import('@pages/questions/show.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/pronostics/:id/forecasters/',
    name: 'pronostics.forecasters',
    component: () => lazyLoadView(import('@pages/forecasters/show.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
        } else next()
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/users/',
    name: 'users',
    component: () =>
      lazyLoadView(import('@views/roles_management/users/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/groups/',
    name: 'groups',
    component: () =>
      lazyLoadView(import('@views/roles_management/groups/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/perms/',
    name: 'perms',
    component: () =>
      lazyLoadView(import('@views/roles_management/perms/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/app-sections/',
    name: 'app-sections',
    component: () =>
      lazyLoadView(import('@views/roles_management/app-sections/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/company-info/',
    name: 'company-info',
    component: () =>
      lazyLoadView(import('@views/roles_management/company-info/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/public_register/:project_id/',
    name: 'PublicRegister',
    component: () =>
      lazyLoadView(import('@pages/projects/public/register/index.vue')),
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        const curtSession = store.getters['auth/currentSession']
        if (!curtSession) return next()
        else next({ name: 'home' })
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/public_project/:project_id/',
    name: 'PublicProject',
    component: () =>
      lazyLoadView(import('@pages/projects/public/project/index.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currtSession = store.getters['auth/currentSession']
        if (currtSession && currtSession.is_public_project) {
          next()
        } else next({ name: 'home' })
      },
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const currSession = store.getters['auth/currentSession']
        let publicProjectId
        if (currSession && currSession.publicProject) {
          next(currSession.publicProject.indexPath)
          publicProjectId = currSession.publicProject.id
        }

        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )

        if (publicProjectId) {
          next({
            name: 'PublicRegister',
            params: { project_id: publicProjectId },
          })
        } else {
          // Navigate back to previous page, or home as a fallback
          next(
            authRequiredOnPreviousRoute
              ? {
                name: 'login',
                params: routeTo.params ? routeTo.params : {},
              }
              : { ...routeFrom }
          )
        }
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
